// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m8Uk","textarea":"styles_textarea__1Wgr1"};